<template>
  <v-container id="login"
    fill-height
    fluid
  >
    <v-layout
      justify-center
      align-center
    >
      <v-flex
        column
        lg4
        align-self-center>
        <material-card
          icon="supervised_user_circle"
          color="green"
          :title="$t('Pages.Login.title')"
          :text="$t('Pages.Login.subtitle')"
        >
          <v-card-text>
            <v-form @submit.prevent="login()">
              <v-layout>
                <v-flex lg12>
                  <v-text-field
                    v-validate="'required|email'"
                    v-model="email"
                    :error-messages="errors.first('email')"
                    prepend-inner-icon="mail_outline"
                    autofocus
                    :label="$t('Core.Fields.email')"
                    type="email"
                    name="email"
                    validate-on-blur
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex lg12>
                  <v-text-field
                    v-validate="'required|min:6'"
                    v-model="password"
                    :error-messages="errors.first('password')"
                    prepend-inner-icon="fingerprint"
                    :label="$t('Core.Fields.password')"
                    type="password"
                    required
                    name="password"
                    counter
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex lg4>
                  <v-btn
                    color="green"
                    dark
                    block
                    type="submit"
                  >
                    {{$t('Pages.Login.title')}}
                  </v-btn>
                </v-flex>
              </v-layout>

            </v-form>
          </v-card-text>
        </material-card>

        <v-layout
          justify-center
          align-center
        >
          <v-flex
                  lg6
                  class="text-lg-left">
            <router-link
                    to="/employee"
                    class="tertiary--text">
              {{$t('Pages.Login.employee')}}
            </router-link>
          </v-flex>
          <v-flex
            lg6
            class="text-lg-right">
            <router-link
              to="/forgot/password"
              class="tertiary--text">
              {{$t('Pages.ForgotPassword.title')}}
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    email: '',
    password: ''
  }),
  mounted () {
  },
  methods: {
    login () {
      this.$validator.validateAll().then((result) => {
        if (result) {
            let self = this;
            this.$auth.login({ email: this.email, password: this.password }).then(function () {
                self.repositories.user.me({include: 'roles,nextScheduledOvertime,nextTravelWarrant'}).then((response) => {
                    self.setMe(response.data.data);
                    self.$router.push(self.$route.query.redirect || '/dashboard');
                });
            }).catch(function (response) {
            return Promise.reject(response.response)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
   #login{
     margin-top: 10%;
   }

  html{
    overflow-y: hidden;
  }
</style>
